import { functions } from '@/firebase'

const createMetaData = async () => {
	const create = functions.httpsCallable('users_create_metadata')

	const result = await create()

	return result.data
}

export {
	createMetaData
}
